import { Component, OnInit, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { MessageTemplateFormComponent } from "../message-template-form/message-template-form.component";
import { takeUntil } from "rxjs/operators";
import { MessageTemplate } from "../../model/message-template.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";

@Component({
  selector: "ngx-message-template-list",
  templateUrl: "./message-template-list.component.html",
  styleUrls: ["./message-template-list.component.scss"],
})
export class MessageTemplateListComponent extends BaseListComponent {
  @ViewChild(KGridComponent) grid: KGridComponent;
  loadMessageTemplate: boolean = false;
  constructor() {
    super();
    this.inputEditorform = MessageTemplateFormComponent;
  }
  async ngOnInit() {
    this.apiName = "MessageTemplate";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Messaging.TemplateMessage.MessagePlatform");
    this.loadData(this.accountService.authService.currentBranchId);
  }
  deleteHandler(data:MessageTemplate) {
    if (data.IsDefault) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Messaging.TemplateMessage.DefaultMessagesCantDelete")
      );
      this.grid.refreshData();
      return;
    }
    else
    {
      this.deleteFormHelper(data);
      this.grid.refreshData();
    }
  }
  deleteFormHelper(dataItem: any) {
    this.dataList.forEach(x => {
      if (((dataItem.Id > 0 && x.Id === dataItem.Id) || x === dataItem)) {
        if (x.State === RowState.New)
          x.State = RowState.Detached;
        else
          x.State = RowState.Delete;
      }
    });
    this.sts.showToast('primary', '', 'در حال حذف...');
    this.httpCommonService.delete('MessageTemplate', dataItem.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(results => {
        this.sts.showToast('success', '', 'اطلاعات با موفیت حذف شد.');
      },
        error => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, 'خطا در حذف اطلاعات');
        });
  }
  async loadData(branchId: number) {
    this.httpCommonService
      .getList(this.apiName + "/GetDefaultMessageTemplate/" + branchId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (row) => {
          this.dataList = row as [];
          this.loadMessageTemplate = true;
        },
        (error) => {}
      );
  }
}
